module.exports = __webpack_public_path__ + "static/img/mk93.52a378c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/mk93.jpg
// module id = xolt
// module chunks = 0